import script from "./SplitCollectionTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SplitCollectionTable.vue?vue&type=script&setup=true&lang=js"

import "./SplitCollectionTable.vue?vue&type=style&index=0&id=33f841ba&lang=scss&scoped=true"
script.__scopeId = "data-v-33f841ba"

export default script